export default __webpack_public_path__ + "57812feda5f1ef8ce7f4ba31cbeb54b7.png";